import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Mara Ellison",
    description: "Mara Ellison is a product designer in Lisbon. Her portfolio is an arcade cabinet: press Enter to open the résumé with experience, projects, education and skills.",
    url: getOrigin()
}

// the header tabs and footer links, in order
export const NAV_LINKS = [
    { href: '/', label: "Home" },
    { href: '/about', label: "About" },
    { href: '/contact', label: "Contact" }
] as const
